module.exports = function() {
  return new Worker(__webpack_public_path__ + "e2c4ba617d505bd25119.worker.js");
};